import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { style } from './indicator.styles';

@customElement('sbk-indicator')
export class SbkIndicator extends LitElement {
    @property({type: String})
    variant: 'info' | 'success' | 'note' | 'error' = 'info';

    @property({type: String})
         
    label: string = '';

    static get styles() {
        return style;
    }

    private getIndicatorClass(variant: string): string {
        switch (variant) {
            case 'success':
                return 'indicator-success';
            case 'error':
                return 'indicator-error';
            case 'note':
                return 'indicator-note';
            case 'info':
                return 'indicator-info';
            default:
                return '';
        }
    }

    render() {
        return html`
            <div class="indicator ${this.getIndicatorClass(this.variant)}">
                <span class="indicator-circle"></span>
                <span class="indicator-label">${unsafeHTML(this.label)}</span>
            </div>
        `;
    }
}
